import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import Spinner from '../../util/spinner-shim'
import { useParams, useNavigate } from 'react-router-dom'
import NavigationBar from '../partials/NavigationBar'
import Scheduler from '../partials/Scheduler/Scheduler'
import Footer from '../partials/Footer'
import StatusSave from '../partials/StatusSave'
import withAppStore from '../../util/withAppStore'

import AppDispatcher from '../../dispatchers/AppDispatcher'

import styles from '../../../css/scheduler.module.css'

const isNumber = x => !isNaN(x) && isFinite(x)

function SchedulePage (props) {
  const { deviceID, customerID, scheduleNumber } = useParams()
  const navigate = useNavigate()

  const getNewData = React.useCallback(() => {
    AppDispatcher.dispatch({
      action: 'get-device',
      deviceID,
    })
  }, [deviceID])

  const backToDevice = React.useCallback(() => {
    navigate(`/${customerID}/devices/${deviceID}`)
  }, [customerID, deviceID, navigate])

  React.useEffect(() => {
    getNewData()
  }, [getNewData])

  React.useEffect(() => {
    return () => {
      AppDispatcher.dispatch({
        action: 'reset-new-settings',
      })
      AppDispatcher.dispatch({
        action: 'pin-code-unload',
      })
    }
  }, [])

  const {
    pages,
    route,
    data: {
      lookup,
      lookupReady,
      deviceSettings: {
        saved,
      },
      pinCode: {
        status: pinCodeStatus,
        cancelled: pinCodeCancelled,
      } = {},
      customer: {
        data: {
          security,
        } = {},
      } = {},
    } = {},
    auth,
  } = props

  const {
    pin: pinCodeRequired = false,
  } = { ...security }

  const device = lookup[deviceID]
  const subMenuName = device ? device.physical.deviceNumber : ''
  const scheduleNumberP = isNumber(scheduleNumber) ? Number(scheduleNumber) : 1
  let schedules = [{ key: scheduleNumberP, events: [] }]

  if (
    typeof device === 'object' &&
    typeof device.application_settings === 'object' && typeof device.application_settings.settings === 'object' &&
    typeof device.application_settings_new === 'object' && typeof device.application_settings_new.settings === 'object'
  ) {
    if (
      device.application_settings_new.status && device.application_settings_new.status === 'new' &&
      device.application_settings_new.settings.schedules &&
      Array.isArray(device.application_settings_new.settings.schedules) &&
      device.application_settings_new.settings.schedules.find((a) => a.key === scheduleNumberP)
    ) {
      schedules = device.application_settings_new.settings.schedules
    } else if (
      device.application_settings.settings.schedules &&
      Array.isArray(device.application_settings.settings.schedules) &&
      device.application_settings.settings.schedules.find((a) => a.key === scheduleNumberP)
    ) {
      schedules = device.application_settings.settings.schedules
    }
  }

  let limit = 35
  if (device && device.configuration && device.configuration.firmware && device.configuration.firmware.productId) {
    switch (Number(device.configuration.firmware.productId)) {
      case 10704:
        limit = 48
        break

      default:
        break
    }
  }

  const visible = !!saved
  const outcome = saved !== true ? 'error' : 'success'

  return (
    <div>
      <Helmet><title>{pages.SchedulePage}</title></Helmet>
      <StatusSave outcome={outcome} visible={visible} />
      <NavigationBar
        page={route.path}
        backFunc={backToDevice}
        name={subMenuName}
        logOut={() => auth.logout(navigate)}
      />
      <div className={styles.pageWidth}>
        {(!lookupReady || !device) && (
          <div className='loading'>
            <Spinner name='double-bounce' />
          </div>
        )}
        {lookupReady && device && (
          <Scheduler
            limit={limit}
            schedules={schedules}
            address={device.address}
            pinCodeRequired={pinCodeRequired}
            pinCodeStatus={pinCodeStatus}
            pinCodeCancelled={pinCodeCancelled}
            scheduleNumber={scheduleNumberP}
          />
        )}
      </div>
      <Footer />
    </div>
  )
}

SchedulePage.propTypes = {
  data: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
  auth: PropTypes.object,
}

export default withAppStore(SchedulePage)
